module.exports = __webpack_public_path__ + "static/img/dx-logo-font.7db5802.png";